export default "__VITE_ASSET__e3h9iNtU__"